(() => {
    const loadingImageObserverCallback = (mutationList) => {
        for (const mutation of mutationList) {
            for (const addedNode of mutation.addedNodes ?? []) {
                if(!(addedNode instanceof HTMLElement)) continue; // no need to look in TextNodes and similar

                const images = addedNode.querySelectorAll('img[currentlyloading="true"]');
                for (const image of images) {
                    if (image.complete) { // if an image has already finished downloading then show the non-blurred
                        image.setAttribute('currentlyloading', 'false');
                    } else { // otherwise register an event listener to do this
                        image.addEventListener('load', function() { this.setAttribute('currentlyloading', 'false'); });
                    }
                }
            }
        }
    }

    // limit the mutation observers to elements with the given class to not slow down the app too much
    const observerParentNodes = document.querySelectorAll('.playfina-loading-image-parent');

    // If there is ever a need to stop the mutation observers from observing the parent elements uncomment this line and the one in the for loop
    // so they are accessible throughout the site and disconnect() can be called on them
    // window.imageLoadingObservers = [];
    for (const parent of observerParentNodes) {
        const observer = new MutationObserver(loadingImageObserverCallback);
        // window.imageLoadingObservers.push(observer);
        observer.observe(parent, { childList: true, subtree: true }); // no need to listen for attribute changes, the handler doesn't deal with them directly
    }
})();